import React, { Component } from "react";
import { Table, Button, Modal, Col, Row, message, Tooltip, Input, Dropdown, Menu, Icon } from "antd";
import axios from "axios";
import "./Pages.css";
import VendaForm from '../components/VendaForm';
import VendasImportarXmlModal from '../components/VendasImportarXmlModal';
import PedidosPrintModal from "../relatorios/PedidosPrintModal";
import PedidoPrintA4Modal from "../relatorios/PedidoPrintA4Modal";
import PedidoPrintCupomModal from "../relatorios/PedidoPrintCupomModal";
import PedidoFiltroForm from '../components/PedidoFiltroForm';
import SpinnerForm from '../components/SpinnerForm';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao } from "../utils/LoginManager";
import Colors from '../utils/Colors';
import Vendas from '../tutoriais/LancVendas';

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Search } = Input;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregandoLista: false,
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    totalVendas: 0,
    qtdeVendas: 0,
    formFiltroVisivel: false,
    formPrintA4Visivel: false,
    formPrintCupomVisivel: false,
    idfVenda: 0,

    filtros: {
      tipoTela: 'VEN',
      buscaOrdem: { campo: 'ven_dt_venda', ordem: 'DESC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth() - 6, 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaControle: '',
      buscaPessoa: { key: '0', },
      buscaProduto: { key: '0', },
      buscaGrupoProduto: { key: '0', },
      buscaMarcaProduto: { key: '0', },
      buscaServico: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaSitFin: { key: 'X', },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregandoLista: true, totalVendas: 0, qtdeVendas: 0 });
    const { pagina, limite } = this.state;
    const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaUsuario, buscaSitFin, buscaOrdem } = this.state.filtros;

    let dataIni = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let dataFim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/vendas', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          numero: buscaControle,
          pessoa: buscaPessoa.key,
          usuario: buscaUsuario.key,
          sitFin: String(buscaSitFin.key),
          dataIni,
          dataFim,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data.dados;
        this.setState({
          listaRegistros: data,
          carregandoLista: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),

          totalVendas: response.data.totalVendas,
          qtdeVendas: response.data.qtdeVendas,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregandoLista: false,
        });
      });
  };



  onSalvarClick = (registro) => {
    this.setState({ salvando: true })

    // console.log('onSalvarClick', registro)

    let request;
    if (registro.ven_idf) {
      request = axios.put(`/vendas/update/${registro.ven_idf}`, registro);
    } else {
      request = axios.post(`/vendas/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })

        if (registro.registroNfe) {
          Modal.success({
            title: 'Nota Fiscal',
            okText: 'OK',
            width: '25%',
            content: (
              <div>
                <div>{'Nota TRANSMITIDA com Sucesso'}</div>
                <div>NFe: {response.data.nfe}</div>
                <div>{response.data.chave ? 'Chave: ' + response.data.chave : ''}</div>
              </div>
            ),
          })
        } else {
          if (!registro.ven_idf) {
            if (this.state.usuario.par_impr_venda_ger === 'COM') {
              this.onImprimirA4Click(response.data.idf);
            } else if (this.state.usuario.par_impr_venda_ger === 'CUP') {
              this.onImprimirCupomClick(response.data.idf);
            }
          }
        }
        message.success('Pedido gravado com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        // console.log('onSalvarClick ERRO: ', error.response);
        if ((error.response) && (error.response.status === 401)) {
          if (error.response.data.status) {
            if ((error.response.data.status === 5001) || (error.response.data.status === 5002)) {
              Modal.error({
                title: 'Nota Fiscal',
                okText: 'OK',
                width: '25%',
                content: (
                  <div>
                    <div>Problema com os dados da Nota Fiscal</div>
                    <div>NFe: {error.response.data.nfe}</div>
                    <div>{error.response.data.chave ? 'Chave: ' + error.response.data.chave : ''}</div>
                    <div>{error.response.data.status ? 'ERRO: ' + error.response.data.status + (error.response.data.mensagem ? ' - ' + error.response.data.mensagem : '') : ''}</div>
                  </div>
                )
              })
            } else {
              Modal.error({
                title: 'Emissão Nota Fiscal',
                okText: 'OK',
                width: '25%',
                content: (
                  <div>
                    <div>Erro no Retorno da SEFAZ</div>
                    <div>NFe: {error.response.data.nfe}</div>
                    <div>{error.response.data.chave ? 'Chave: ' + error.response.data.chave : ''}</div>
                    <div>Mensagem: {error.response.data.mensagem}</div>
                    <div>{error.response.data.status ? 'ERRO: ' + error.response.data.status + (error.response.data.mensagem ? ' - ' + error.response.data.mensagem : '') : ''}</div>
                  </div>
                )
              })
            }
          } else {
            Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
          }
        } else {
          Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        }

        this.getListaRegistros();
      })
  }

  onAdicionarClick = () => {
    axios.get(`/caixas/caixaAberto`, { params: { id: 0, cta: 0, data: '', situacao: 'X', } })
      .then(response => {
        const { data } = response;

        this.setState({
          formVisivel: true,
          visualizar: false,
          registroSelecionado: {
            dados: {
              ven_idf: 0,
              ven_numero: '',
              ven_dt_venda: data && data.cx_data ? moment(data.cx_data).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY'),
              ven_obs: '',
              ven_qtde_itens: 0,
              ven_vlr_itens: 0,
              ven_vlr_acres: 0,
              ven_vlr_desc: 0,
              ven_vlr_desc_venda: 0,
              ven_vlr_total: 0,
              ven_pessoa: {
                key: String(this.state.usuario.par_cliente),
                label: this.state.usuario.pes_nome_cli,
              },
              ven_usuario: {
                key: this.state.usuario.par_vendedor ? String(this.state.usuario.par_vendedor) : '0',
                label: this.state.usuario.par_vendedor ? this.state.usuario.usu_nome : '',
              },
              ven_tipo_doc: {
                key: String(this.state.usuario.par_doc_padrao),
                label: this.state.usuario.td_descricao,
              },
              ven_cond_pagto: {
                key: String(this.state.usuario.par_cond_pagto_padrao),
                label: this.state.usuario.td_descricao,
                qtdeParc: this.state.usuario.cp_qtde_parc,
                parcAVista: this.state.usuario.cp_parc_avista,
              },
              listaProdutos: [],
              visualizando: false,
              ven_emitir_nfe: false,
            }
          },
          registroParcela: {
            tparc_parcela: 0,
            tparc_data_parcela: '',
            tparc_tipo_doc: { key: '0' },
            tparc_conta_corrente: { key: '0' },
            tparc_valor: 0,
            tparc_situacao: { key: 'A', label: 'ABERTO', },
            tparc_obs: '',
            td_descricao: '',
            cc_descricao: '',
            situacao_parcela: '',
            pgto_vlr_desconto: 0,
            pgto_vlr_acrescimo: 0,
            pgto_vlr_pago: 0,
            pgto_vlr_restante: 0,
            pgto_data: '',
            pgto_cta_corrente: '',
          }
        })

      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onEditarClick = (registro, visualizar) => {
    this.setState({ carregando: true });
    axios.get(`/vendas/show/${registro.ven_idf}`)
      .then(response => {
        const { data } = response;

        data.dados.ven_pessoa = {
          key: String(data.dados.ven_pessoa),
          label: data.dados.pes_nome,
        }
        data.dados.ven_usuario = {
          key: String(data.dados.ven_usuario),
          label: data.dados.usu_nome,
        }
        data.dados.ven_cond_pagto = {
          key: data.dados.ven_cond_pagto ? String(data.dados.ven_cond_pagto) : '',
          label: data.dados.cp_descricao,
          qtdeParc: data.dados.cp_qtde_parc,
          parcAVista: data.dados.cp_parc_avista,
        }
        data.dados.ven_tipo_doc = {
          key: (data.listaParcelas.length > 0 && data.listaParcelas[0].tparc_tipo_doc) ? String(data.listaParcelas[0].tparc_tipo_doc) : '',
          label: (data.listaParcelas.length > 0 && data.listaParcelas[0].td_descricao) ? String(data.listaParcelas[0].td_descricao) : '',
        }

        data.dados.ven_dt_venda = moment(data.dados.ven_dt_venda, 'YYYY-MM-DD').format('DD/MM/YYYY');

        data.dados.visualizando = false;

        this.setState({
          formVisivel: true,
          registroSelecionado: {
            ...data,
            visualizar,
          },
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregandoLista: true });
        axios.delete(`/vendas/delete/${registro.ven_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.ven_idf === registro.ven_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregandoLista: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregandoLista: false,
            })
            if (error.response.status === 412) {
              Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
            } else {
              Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
            }
          })
      }
    })
  };

  onImprimirA4Click = (ven_idf) => {
    this.setState({
      idfVenda: ven_idf,
      formPrintA4Visivel: true,
    });
  };

  onImprimirCupomClick = (ven_idf) => {
    this.setState({
      idfVenda: ven_idf,
      formPrintCupomVisivel: true,
    });
  };

  onCancelarPrintClick = () => {
    this.setState({
      idfVenda: 0,
      formPrintA4Visivel: false,
      formPrintCupomVisivel: false
    })
  }


  onImprimirNFeClick = (registro) => {
    this.setState({ carregando: true });
    axios
      .get('/notas_fiscais/imprimir', {
        params: {
          emitente: registro.nf_emitente,
          idf: registro.nf_idf,
          chave: registro.nf_chave,
        }
      })
      .then(response => {
        const { data } = response;
        if (data.sucesso) {
          const file_url = 'https://api.fastgestor.plenasistemas.inf.br/image/emp' + this.state.usuario.emp_codigo + '/pdf/' + data.url;
          window.open(file_url, '_blank')
        } else {
          Modal.error({ title: 'Falha - Atenção!', width: '25%', content: 'Não foi possível IMPRIMIR. ' + data.mensagem, okText: 'OK', })
        }
        this.setState({
          carregando: false,
        })
      })
      .catch(error => {
        // console.log(error.response);
        Modal.error({ title: 'Erro ao Imprimir', width: '25%', content: error.response.data.mensagem, okText: 'OK', })
        this.setState({
          carregando: false,
        })
      })
  };


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    this.setState({
      [id]: value
    });
  };


  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaControle: String(this.state.filtros.buscaControle),
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaMarcaProduto: this.state.filtros.buscaMarcaProduto,
        buscaServico: this.state.filtros.buscaServico,
        buscaSitFin: this.state.filtros.buscaSitFin,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };


  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };


  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }


  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {getTemPermissao('VendasPage', 'editar') ? (
          <span>
            <Tooltip title="Editar">
              <Button type="primary" size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
            </Tooltip>
          </span>
        ) : (
          <span>
            <Tooltip title="Visualizar">
              <Button type="ghost" size="small" onClick={() => this.onEditarClick(registro, true)} icon="eye" />
            </Tooltip>
          </span>
        )}
        {getTemPermissao('VendasPage', 'excluir') ? (
          <span>
            <Tooltip title="Excluir">
              <Button type="danger" size="small" disabled={registro.nf_idf} onClick={() => this.onExcluirClick(registro)} icon="delete" />
            </Tooltip>
          </span>
        ) : null}

        <span>
          <Tooltip title="Impressão">
            <Dropdown overlay={
              <Menu >
                <Menu.Item key="1" onClick={() => this.onImprimirA4Click(registro.ven_idf)}>Completa</Menu.Item>
                <Menu.Item key="2" onClick={() => this.onImprimirCupomClick(registro.ven_idf)}>Cupom</Menu.Item>
                {(registro.nf_idf && ((registro.nf_status === 1) || (registro.nf_status === 4))) ?
                  (<Menu.Item key="2" onClick={() => this.onImprimirNFeClick(registro)}>DANFE NFe</Menu.Item>)
                  : null}
              </Menu>
            } placement="bottomRight">
              <Button type="ghost"><Icon type="printer" /></Button>
            </Dropdown>
          </Tooltip>
        </span>
      </ButtonGroup>
    );
  };

  renderSitFinanc = (tit_situacao) => {
    return (
      <span> {!tit_situacao ? 'VAZIO' : tit_situacao === 'P' ? 'PAGO' : 'ABERTO'} </span>
    );
  };

  renderValor = (ven_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderUsuario = (usu_nome) => {
    return (
      <span>{usu_nome.substring(0, 10)}</span>
    );
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  onBuscar = (texto) => {
    this.setState({
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaControle: String(texto),
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaMarcaProduto: this.state.filtros.buscaMarcaProduto,
        buscaServico: this.state.filtros.buscaServico,
        buscaSitFin: this.state.filtros.buscaSitFin,
      }
    },
      this.getListaRegistros);
  };


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, carregandoLista, formVisivel, salvando, registroSelecionado,
      filtros, formFiltroVisivel, formPrintA4Visivel, formPrintCupomVisivel, total, pagina, limite } = this.state;

    // console.log('VendasPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        {this.state.importarXmlVisivel && (
          <VendasImportarXmlModal
            onCancelar={() => this.setState({ importarXmlVisivel: false })}
            onImportado={this.getListaRegistros}
          />
        )}

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="tituloPage">Gerenciar Vendas</span>
          <div>
            <Tooltip title="Video de Ajuda">
              <Button
                type="primary"
                onClick={() => window.open('https://www.youtube.com/watch?v=yFCTeCgTASg&list=PLpe5WZ31yjQa5k3LuG7hBzmY1J-mOW3zz&index=2', '_blank')}
                icon="youtube"
                className="botao-ajuda"
              ></Button>
            </Tooltip>
            <Tooltip title="Ajuda">
              <Button
                type="primary"
                onClick={() => this.setState({ modalOpen: true })}
                icon="question"
                className="botao-ajuda"
              ></Button>
            </Tooltip>
          </div>
        </div>
        <div className="divider-page1" />

        <div className="pageFiltro" style={{ height: 50 }}>
          <Col xs={24} >
            <Col xs={12}>
              {getTemPermissao('VendasPage', 'novo') ? (
                <Col xs={2} style={{ width: 110 }}>
                  <Button
                    type="primary"
                    onClick={this.onAdicionarClick}
                    className="botao-primary"
                  >
                    Adicionar
                  </Button>
                </Col>
              ) : null}

              <Col xs={2} style={{ width: 110 }}>
                <Button
                  type="primary"
                  onClick={this.onAbrirFiltroClick}
                  className="botao-primary"
                  style={{ marginRight: 15 }}
                >
                  Filtrar
                </Button>
              </Col>

              <Col xs={2} style={{ width: 150 }}>
                {getTemPermissao('VendasPage', 'novo') && (
                  <Button icon="upload" className="botao-primary" type="primary"
                    style={{ marginRight: 12, width: 140 }}
                    onClick={() => this.setState({ importarXmlVisivel: true })}>
                    Importar XML
                  </Button>
                )}
              </Col>

              <Col xs={2} style={{ width: 110 }}>
                <PedidosPrintModal
                  filtros={filtros}
                  totalVendas={this.state.totalVendas}
                  qtdeVendas={this.state.qtdeVendas}
                />
              </Col>

              <Col xs={6}>
                <Search
                  placeholder="Número"
                  onSearch={this.onBuscar}
                  enterButton
                  className="pageFiltro-busca"
                />
              </Col>

              <PedidoFiltroForm
                visivel={formFiltroVisivel}
                onFiltrarClick={this.onFiltrarClick}
                onCancelarFiltroClick={this.onCancelarFiltroClick}
                filtros={filtros}
              />

              <Vendas
                isOpen={this.state.modalOpen}
                onClose={() => this.setState({ modalOpen: false })}
              />
              <SpinnerForm visivel={carregando} texto={'Carregando Aguarde...'} />

            </Col>

            <Col xs={24} md={8} style={{ height: 65, padding: 5, marginTop: -25 }}>
              <Col xs={24} md={12} style={{ height: 65, padding: 5 }}>
                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                  <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                      Qtde Vendas
                    </span>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Row style={{ marginTop: -5 }}>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.state.qtdeVendas}</span>
                    </Row>
                  </Row>
                </div>
              </Col>
              <Col xs={24} md={12} style={{ height: 65, padding: 5 }}>
                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                  <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                      Valor Total
                    </span>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Row style={{ marginTop: -5 }}>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.totalVendas)}</span>
                    </Row>
                  </Row>
                </div>
              </Col>
            </Col>
          </Col>

          <VendaForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />

          <PedidoPrintA4Modal
            visivel={formPrintA4Visivel}
            ven_idf={this.state.idfVenda}
            tipoVenda="V"
            onCancelarPrintClick={this.onCancelarPrintClick}
          />

          <PedidoPrintCupomModal
            visivel={formPrintCupomVisivel}
            ven_idf={this.state.idfVenda}
            tipoVenda="V"
            onCancelarPrintClick={this.onCancelarPrintClick}
          />

        </div>



        <div style={{ paddingTop: 0 }}>
          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40', '50'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregandoLista,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            rowKey={(registro => registro.ven_idf)}
          >
            <Column
              key="ven_numero"
              dataIndex="ven_numero"
              title={this.renderTitulo("Número")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={80}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="ven_dt_venda"
              dataIndex="ven_dt_venda"
              title={this.renderTitulo("Emissão")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={120}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="pes_nome"
              dataIndex="pes_nome"
              title={this.renderTitulo("Cliente")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={180}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="ven_obs"
              dataIndex="ven_obs"
              title={this.renderTitulo("OBS")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={100}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="usu_nome"
              dataIndex="usu_nome"
              title={this.renderTitulo("Vendedor")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={90}
              align="left"
              className="listaCadastro"
              render={this.renderUsuario}
            />
            <Column
              key="ven_vlr_total"
              dataIndex="ven_vlr_total"
              title={this.renderTitulo("Valor Total")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderValor}
              width={90}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="tit_situacao"
              dataIndex="tit_situacao"
              title={this.renderTitulo("Sit. Financ.")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderSitFinanc}
              width={100}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="nf_numero"
              dataIndex="nf_numero"
              title={this.renderTitulo("NFe")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={80}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="situacao_nota"
              dataIndex="situacao_nota"
              title={this.renderTitulo("Sit NFe")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={80}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="acoes"
              title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
              render={this.renderAcoes}
              width={120}
              align="center"
              className="listaCadastro"
            />
          </Table>
        </div>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/VendasPage.js